import { useWeb3 } from '../contexts/Web3Context'

function truncateAddress(address: string): string {
  return `${address.slice(0, 6)}...${address.slice(-4)}`
}

export function Nav() {
  const { address, isConnected, openModal } = useWeb3()

  return (
    <nav className="fixed top-0 w-full bg-gray-800 border-b border-gray-700 z-50 text-white">
      <div className="max-w-3xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <span className="text-xl font-semibold text-pulse-gradient">
            PulseChain Sponsor Bot
          </span>

          {isConnected && address ? (
            <button
              onClick={openModal}
              className="flex items-center gap-2 px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg hover:bg-gray-600 transition-colors"
            >
              <div className="w-2 h-2 bg-green-500 rounded-full" />
              <span className="text-sm font-mono text-gray-200">
                {truncateAddress(address)}
              </span>
            </button>
          ) : (
            <button
              onClick={openModal}
              className="px-4 py-2 text-sm font-medium text-white bg-pulse-gradient hover:opacity-90 rounded-lg transition-colors"
            >
              Connect Wallet
            </button>
          )}
        </div>
      </div>
    </nav>
  )
}
